export const USER_DETAIL_PROCESS = "/company/process/user/detail/"

export const handleFetchError = (text: any) => {
  return text
}
